import React, { useEffect } from "react";

import { NotificationContainer } from "react-notifications";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Login from "./Login";
import Map from "./map";
import Socket from "./Socket";

import ManagementDevices from "./management/devices";
import ManagementDevicesEdit from "./management/devices/Edit";

import ManagementUsers from "./management/users";
import ManagementUsersEdit from "./management/users/Edit";
import ManagementUsersEditDevices from "./management/users/Devices";

import { useDispatch, useSelector } from "react-redux";
import { sessionActions } from "./store";
import Conf from "../conf";

const App = () => {
    const dispatch = useDispatch();

    const login = !!useSelector((state) => state.session.user);
    const is_devices_loaded = useSelector((state) => state.devices.loaded);

    useEffect(() => {
        console.log("%cWritten by Artan Technologies Co. (https://arianartan.com/)", "color: #4287f5; font-size: 1rem; font-family: Arial; font-weight: bolder;");

        fetch(`${Conf.server_address}/session`, {
            method: "GET",
            credentials: "include",
        }).then((response) => {
            if (response.status === 200) {
                response.json().then((Json) => {
                    dispatch(sessionActions.updateUser(Json));
                });
            } else {
                if (window.location.pathname !== "/") window.location.href = "/";
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {login ? <Socket /> : []}
            <BrowserRouter basename={"/"}>
                <Routes>
                    <Route exact path={login ? "/" : "*"} element={<Login />} />

                    {login && is_devices_loaded && (
                        <>
                            <Route path="/map" element={<Map />} />
                            <Route path="/management/devices/edit/:DeviceID" element={<ManagementDevicesEdit />} />
                            <Route path="/management/devices" element={<ManagementDevices />} />

                            <Route path="/management/users/edit/:UserID/devices" element={<ManagementUsersEditDevices />} />
                            <Route path="/management/users/edit/:UserID" element={<ManagementUsersEdit />} />
                            <Route path="/management/users/" element={<ManagementUsers />} />
                        </>
                    )}
                </Routes>

                <NotificationContainer />
            </BrowserRouter>
        </>
    );
};

export default App;
